<template>
    <div class="w-76 border">
        <TemplateTab v-if="activetab === 'Templates'" />
        <TextTab v-else-if="activetab === 'Text'" />
        <MediaTab v-else-if="activetab === 'Media'" />
        <!-- <PhotosTab v-else-if="activetab === 'Photos'" />
        <GiphyTab v-else-if="activetab === 'Giphy'" />
        <PexelsTab v-else-if="activetab === 'Pexels'" /> -->
        <AppsTab v-else-if="activetab === 'Apps'" />
        <StickersTab v-else-if="activetab === 'Stickers'" />
        <SettingsTab v-else-if="activetab === 'Settings'" />
    </div>
  </template>
  
  <script>
    import TemplateTab from "./SidebarPanelTabs/Templates.vue"
    import TextTab from "./SidebarPanelTabs/Text.vue"
    import MediaTab from "./SidebarPanelTabs/Media.vue"
    // import PhotosTab from "./SidebarPanelTabs/Photos.vue"
    // import GiphyTab from "./SidebarPanelTabs/Giphy.vue"
    // import PexelsTab from "./SidebarPanelTabs/Pexel.vue"
    import AppsTab from "./SidebarPanelTabs/Apps.vue"
    import SettingsTab from "./SidebarPanelTabs/Settings.vue"
    import StickersTab from "./SidebarPanelTabs/Stickers.vue"
  export default {
    name: 'SideBarPanel',
    components:{
        TemplateTab,
        TextTab,
        MediaTab,
        // PhotosTab,
        // GiphyTab,
        // PexelsTab,
        AppsTab,
        StickersTab,
        SettingsTab
    },
    props: {
        activetab: String,
    }
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>

  </style>
  